module.exports = __webpack_public_path__ + "img/intesarbm-logo-no-bg.9b72f9be.png";